import { Link } from 'react-router-dom';
import { stats } from '@/mocks/news';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Breaking%20news%20dramatic%20scene%20with%20paparazzi%20flashes%20and%20crowd%20chaos%2C%20dark%20crimson%20atmosphere%2C%20cinematic%20lighting%2C%20silhouettes%20against%20red%20spotlights%2C%20editorial%20journalism%20photography%2C%20high%20drama%2C%20press%20conference%20chaos%2C%20moody%20and%20intense%20vibe&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="每日大赛黑料网 - 网红大瓜实时追踪"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-black/30"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="max-w-3xl">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight">
              网红大瓜
              <br />
              实时追踪
              <br />
              <span className="text-primary-500">吃瓜爆料第一手</span>
            </h1>
            <div className="flex flex-col sm:flex-row gap-8 sm:gap-16 mt-8 md:mt-12">
              <div className="max-w-md">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  每日大赛黑料网 —— 聚合每日大赛黑料最新爆料、网红塌房现场、博主反差视频等一手资讯。黑料每日更新，吃瓜永不停歇。
                </p>
              </div>
              <div className="flex gap-8 md:gap-12 mt-2 sm:-mt-1">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-2xl md:text-3xl font-heading font-black text-accent-500">
                      {stat.value}<span className="text-lg md:text-xl">{stat.unit}</span>
                    </div>
                    <div className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-8 flex gap-3">
              <Link
                to="/category/wanghong-tafang"
                className="bg-primary-500 text-foreground-950 px-6 py-3 rounded-md text-sm font-label font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1.5"></i>
              </Link>
              <Link
                to="/about"
                className="border border-foreground-700/40 text-foreground-950 px-6 py-3 rounded-md text-sm font-label font-medium whitespace-nowrap hover:border-foreground-700 hover:bg-foreground-950/5 transition-all duration-200"
              >
                下载APP
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}